"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Credentials = exports.decodeCredentials = void 0;

var credentials_1 = require("./storage/credentials");

exports.decodeCredentials = function (hash) {
  var e_1, _a; // e.g. #access_token=deadbeefbc1f252432878d67d1fdc10d000bb58e7bc372241ce5a0000&expires_in=86400&scope=config+users+writedata+writeusers+data+alerts+writeconnections+writealerts+connections+status+writeunits+writeprofiles+units+profiles+user+writeconfig&state=&token_type=token


  if (hash.length < 68) {
    throw Error("Input hash too short");
  }

  var ret = new Credentials();

  if (hash.charAt(0) === "#") {
    hash = hash.substr(1);
  } // we strip the first char if it is #


  var hashParts = hash.split("&");
  var token = "";
  var expiresIn = "";
  var scope = "";

  try {
    for (var hashParts_1 = __values(hashParts), hashParts_1_1 = hashParts_1.next(); !hashParts_1_1.done; hashParts_1_1 = hashParts_1.next()) {
      var item = hashParts_1_1.value;
      var itemSplit = item.split("=");

      if (itemSplit[0] === "access_token") {
        token = itemSplit[1];
      }

      if (itemSplit[0] === "expires_in") {
        expiresIn = itemSplit[1];
      }

      if (itemSplit[0] === "scope") {
        scope = itemSplit[1];
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (hashParts_1_1 && !hashParts_1_1.done && (_a = hashParts_1.return)) _a.call(hashParts_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  ret.setToken(token, expiresIn, scope);
  return ret;
};

var Credentials =
/** @class */
function () {
  function Credentials() {
    this.token_ = "";
    this.expiresIn_ = 0;
    this.expiresAt_ = new Date();
    this.scope_ = [];
    this.userAgent_ = "";
    this.referer_ = "";
  }

  Credentials.prototype.load = function () {
    var _this = this;

    return credentials_1.load().then(function (cred) {
      if (cred != null) {
        _this.setTokenDate(cred.token_, cred.expiresAt_, cred.scope_);
      }

      return _this;
    });
  };

  ;

  Credentials.prototype.store = function () {
    return credentials_1.store(this);
  };

  ;

  Credentials.prototype.clear = function () {
    return credentials_1.clear();
  };

  Credentials.prototype.setToken = function (token, expiresIn, scope) {
    var scopeArr = [];

    if (scope && scope.length > 1) {
      scopeArr = scope.split("+");
    }

    this.setTokenTTL(token, parseInt(expiresIn), scopeArr);
  };

  Credentials.prototype.setTokenTTL = function (token, expiresIn, scope) {
    this.expiresIn_ = expiresIn;
    this.setTokenDate(token, this.calculateExpiresAt(this.expiresIn_), scope);
  };

  Credentials.prototype.setTokenDate = function (token, expiresAt, scope) {
    if (!this.validateToken(token)) {
      throw new Error("Token pre-validation failed, token length incorrect");
    }

    this.token_ = token;
    this.expiresAt_ = expiresAt;
    this.scope_ = scope;

    if (this.expiresIn_ === 0) {
      this.expiresIn_ = Number.MAX_VALUE;
    }
  };

  Credentials.prototype.setUserAgent = function (userAgent) {
    this.userAgent_ = userAgent;
  };

  Credentials.prototype.setReferer = function (referer) {
    this.referer_ = referer;
  };

  Credentials.prototype.token = function () {
    return this.token_;
  };

  Credentials.prototype.scope = function () {
    return this.scope_;
  }; // expiresAt returns the Date of expiry of the given token


  Credentials.prototype.expiresAt = function () {
    return this.expiresAt_;
  };

  ;

  Credentials.prototype.userAgent = function () {
    return this.userAgent_;
  };

  Credentials.prototype.referer = function () {
    return this.referer_;
  };

  Credentials.prototype.expired = function () {
    return this.expiresAt_.getTime() - new Date().getTime() < 1;
  };

  Credentials.prototype.valid = function () {
    return !this.expired() && this.validateToken(this.token_);
  };

  Credentials.prototype.validateToken = function (token) {
    if (token && token.length === 56) {
      return true;
    }

    return false;
  };

  ; // Lifetime is given in seconds, this needs to be milliseconds for javascript timestamps

  Credentials.prototype.calculateExpiresAt = function (lifetime) {
    return new Date(lifetime * 1000 + new Date().getTime());
  };

  ;
  return Credentials;
}();

exports.Credentials = Credentials; //export default Credentials;